"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawerPositions = exports.backgroundFadeIn = exports.backgroundFadeOut = exports.openDrawerKeyframes = exports.closeDrawerKeyframes = void 0;

var _styledComponents = require("styled-components");

var closeDrawerKeyframes = {
  top: (0, _styledComponents.keyframes)(["from{transform:translate3d(0,0,0);}to{transform:translate3d(0,-100vh,0);}"]),
  bottom: (0, _styledComponents.keyframes)(["from{transform:translate3d(0,0,0);}to{transform:translate3d(0,100vh,0);}"]),
  left: (0, _styledComponents.keyframes)(["from{transform:translate3d(0,0,0);}to{transform:translate3d(-100vw,0,0);}"]),
  right: (0, _styledComponents.keyframes)(["from{transform:perspective(50px) translate3d(0,0,0);}to{transform:perspective(50px) translate3d(100vw,0,-200px);}"])
};
exports.closeDrawerKeyframes = closeDrawerKeyframes;
var openDrawerKeyframes = {
  top: (0, _styledComponents.keyframes)(["from{transform:translate3d(0,-100vh,0);}to{transform:translate3d(0,0,0);}"]),
  bottom: (0, _styledComponents.keyframes)(["from{transform:translate3d(0,100vh,0);}to{transform:translate3d(0,0,0);}"]),
  left: (0, _styledComponents.keyframes)(["from{transform:translate3d(-100vw,0,0);}to{transform:translate3d(0,0,0);}"]),
  right: (0, _styledComponents.keyframes)(["from{transform:perspective(50px) translate3d(100vw,0,-200px);}to{transform:perspective(50px) translate3d(0,0,0);}"])
};
exports.openDrawerKeyframes = openDrawerKeyframes;
var backgroundFadeOut = (0, _styledComponents.keyframes)(["from{opacity:1;}to{opacity:0;}"]);
exports.backgroundFadeOut = backgroundFadeOut;
var backgroundFadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
exports.backgroundFadeIn = backgroundFadeIn;
var drawerPositions = {
  top: {
    bottom: 'auto',
    left: 0,
    right: 0,
    top: 0
  },
  bottom: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 'auto'
  },
  left: {
    left: 0,
    right: 'auto'
  },
  right: {
    left: 'auto',
    right: 0,
    transformOrigin: '100% 5%'
  }
};
exports.drawerPositions = drawerPositions;